module.exports = __webpack_public_path__ + "static/media/Illustration_Collega.c9b5e7e1.svg";